module.exports = __webpack_public_path__ + "static/media/logohotel1.858dd035.svg";